import { Box, Grid, Paper, Typography } from "@mui/material";
import {
  LightbulbOutlined,
  ParkOutlined,
  RoomServiceOutlined,
} from "@mui/icons-material";
import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";


const AppCard = props => {
  const { title, icon, description, bgColor, color } = props;
  const isSmartphoneScreen = useMediaQuery("(max-width: 350px)");
  const isSmallScreen = useMediaQuery("(max-width: 500px)");
  const isMediumScreen = useMediaQuery("(max-width: 768px)");
  return (
    <Box style={{ zIndex: 1,width: "100%" }}>
      <Paper
        elevation={16}
        style={{
          padding:  isSmartphoneScreen ? "36px" : isSmallScreen ? "56px" : isMediumScreen ? "66px":  "76px",
          background: bgColor || "#fafafa",
          color: color || "#fff",
          borderRadius: "60px",
        }}
      >
        <Grid
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={5}
          style={{
            
            display: "flex",
            gap: "32px",
          }}
        >
          {icon && (
            <Grid item style={{ textAlign: "center" }}>
              {icon === "light" ? (
                <LightbulbOutlined style={{ fontSize: "65px" }} />
              ) : icon === "bell" ? (
                <RoomServiceOutlined style={{ fontSize: "65px" }} />
              ) : icon === "tree" ? (
                <ParkOutlined style={{ fontSize: "65px" }} />
              ) : (
                <></>
              )}
            </Grid>
          )}
          <Grid item>
            <Typography
              variant="h4"
              align="center"
              style={{ textTransform: "capitalize" }}
            >
              {title}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" align="center">
              {description}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default AppCard;
